import Http from "./index";

export const login = (params = "") => Http.post(`/auth/login`, params);
export const reset = (params = "") => Http.post(`/auth/forgot`, params);
export const profile = (params = "") => Http.get(`/profile`, params);

export const newPassword = (params = "") => Http.put(`/user/password`, params);

export const forgotPassword = (params = "") => Http.put(`/auth/forgot`, params);
export const advProfile = (params = "") =>
  Http.get(`/profile/recomendations`, params);
export const updateProfile = (params = "") =>
  Http.put(`/user/${params.id}`, params);
export const getMyData = (params = "") => Http.get(`/user`, params);
export const updateShared = (params = "") =>
  Http.put(`/profile/shared/${params.id}`, params);
export const notifications = (params = "") =>
  Http.get(`/notifications?limit=5`, params);
export const notificationsSchedule = (params = "") =>
  Http.get(`/notifications/schedule?currentDate=${params.date}`, params);
export const deleteNotifications = () => Http.delete(`/notifications/delete`);
